import { useState } from "react";
import { useModal } from "../contexts";
import useUser from "../hooks/useUser";
import Modal from "./Modal";
import SmallTextInputField from "./SmallTextInputField";
import { putData } from "../backend";
import ErrorModal from "./ErrorModal";
import { useTranslation } from "react-i18next";
import { Team } from "../interfaces";

interface Props {
  onUpdateTeam: (team: Team) => void;
}

function SettingsTeamModalEdit(props: Props) {
  const { t } = useTranslation();
  const { closeModal, openModal } = useModal();

  const { user, refreshUser } = useUser();

  const [team, setTeam] = useState(user!.activeTeam!);
  const [saveState, setSaveState] = useState<"INITIAL" | "SAVING" | "SAVED">("INITIAL")

  async function handleSave() {
    setSaveState("SAVING");

    try {
      const updatedTeam = await putData("/auth/team/", team)
        .then((team) => {
          refreshUser((user: any) => ({ ...user, team }));
          return team;
        })

      setSaveState("SAVED");

      props.onUpdateTeam(updatedTeam);
      closeModal();

    } catch (error) {
      openModal(<ErrorModal details={error} />)
    }
  }

  return (
    <Modal
      title={t("Edit Team Name")}
      secondaryButtonProps={{
        text: t("Cancel"), onClick: () => closeModal()
      }}
      primaryButtonProps={{
        onClick: handleSave, disabled: saveState === "SAVING", text: saveState === "SAVING" ? t("Saving...") : t("Save")
      }}
      size="sm"
    >
      <div className="flex flex-col">
        <SmallTextInputField value={team.name} onChange={(name) => setTeam(t => ({ ...t, name }))} label={t("Team Name")} />

      </div>
    </Modal>
  );
}

export default SettingsTeamModalEdit;
